import React from 'react'
import MainDataCheck from '../AddAsset/ProgressChecks/MainDataCheck'
import JobfunctionsCheck from '../AddAsset/ProgressChecks/JobfunctionsCheck'
import styled from 'styled-components'
import { useAssetDataState } from '../../../stores/AssetDataProvider'

const StyledList = styled.ul`
  list-style: none;
  margin: 5px 0 0 0;
  padding: 0;
  font-size: 18px;

  li {
    padding: 10px 0;
  }
`

const Progress = () => {
  const { activities,  mainData, selectableAvtivities, loadingActivities } = useAssetDataState()

  return (
    <StyledList>
      <li>
        <MainDataCheck mainData={mainData} />
      </li>
      {!loadingActivities && selectableAvtivities && selectableAvtivities.length > 0 &&
      <li>
        <JobfunctionsCheck activities={activities} />
      </li>}
    </StyledList>
  )
}

export default Progress
